import React from "react";
import { LinearProgress } from "@mui/material";

import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";

interface CourseProgressBarProps {
  label: string;
  value: number;
  trackColor?: string;
  gradientEndColor?: string;
  height?: number;
}

function CourseProgressBar({
  label,
  value,
  trackColor = "#dce6f2",
  gradientEndColor = "#4f9cf9",
  height = 6,
}: CourseProgressBarProps): React.JSX.Element {
  const normalizedValue = Math.max(0, Math.min(100, Number(value || 0)));

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.75}>
        <Typography variant="caption" fontWeight="medium" color="text">
          {label}
        </Typography>
        <Typography variant="caption" fontWeight="bold">
          {Math.round(normalizedValue)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={normalizedValue}
        sx={{
          height,
          borderRadius: 999,
          backgroundColor: trackColor,
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            background: `linear-gradient(90deg, #0a66c2 0%, ${gradientEndColor} 100%)`,
          },
        }}
      />
    </Box>
  );
}

export default CourseProgressBar;